var $361c604b0fc269a3$exports = {};
$361c604b0fc269a3$exports = {
  "removeButtonLabel": "Quitar",
  "removeDescription": "Pulse Eliminar para quitar la etiqueta."
};
export { $361c604b0fc269a3$exports as default };